export default __webpack_public_path__ + "static/media/empty_gift_medium.cc8b9817.svg";